<template>
<section id="contact" class="page grid">
  <navigation-top/>
  <h1>CONTACT</h1>
  <section class="devis">

    <p>
      DEMANDER UN DEVIS <span class="g"><br/>(</span><span class="y">GRATUITEMENT</span><span class="g">)</span>
    </p>

    <p>
      <small>Je m'engage à vous fournir une <strong>réponse</strong> dans les plus <strong>bref délais</strong>.</small>
    </p>

    <p>
      <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 512 512">
          <path fill="#9ea8c8" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z" />
        </svg>
      <a class href="mailto:kevin.lesaout@gmail.com" title="contact gmail de kévin le saout, n'hésitez pas à m'envoyer une demande de devis.">CONTACTEZ MOI</a>
    </p>

    <form method="POST" action="https://formspree.io/kevin.lesaout@gmail.com">
      <input type="email" name="email" placeholder="Votre adresse email">
      <textarea name="message" placeholder="Votre message" rows="8"></textarea>
      <button type="submit">Envoyer</button>
    </form>

  </section>

  <section id="about" class="devis">
    <p>
      VOUS POUVEZ ÉGALEMENT ME RETROUVER ICI :
    </p>
    <aside>
    <ul>
      <li>
        <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 512 512"><path fill="#fff" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z" /></svg>
        <strong><a href="mailto:kevin.lesaout@gmail.com" title="email personnel de kévin le saout, gmail, n'hésitez pas à me contacter pour plus d'informations.">Email</a></strong>
      </li>
      <li>
        <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 320 512"><path fill="#fff" d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" /></svg>
        <a href="http://facebook.com/endorfine.fr/" title="page officiel facebook de mon activité d'indépendant, freelance, dans le secteur de création sur internet">Facebook</a>
      </li>
      <li>
        <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 512 512"><path fill="#fff" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" /></svg>
        <a href="https://twitter.com/endorfine_fr" title="twitter officiel du site web endorfine, kévin le saout">Twitter</a>
      </li>
      <li>
        <p>
          <svg xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 384 512" ><path fill="#fff" d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z" /></svg>
          <small>Situé à <a href="https://www.google.fr/maps/search/29000+Quimper/" title="Auto-entrepreneur sur Quimper (29000), Finistère, Bretagne, France">Quimper (29)</a></small>
        </p>
      </li>
    </ul>
    </aside>
  </section>

</section>
</template>

<script>
import {meta} from '../meta'
import NavigationTop from '@/components/Template_Navigation_Top'

export default {
  name: 'contact',
  components: {
    'navigation-top': NavigationTop
  },
  data () {
    return {
    }
  },
  beforeCreate () {
    var metaTitle = 'Contact'
    var metaDesc = 'Vous avez besoin de me contacter un pour projet? Retrouvez mes coordonnées et le formulaire de contact ici.'
    meta(metaTitle, metaDesc)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page_Contact.vue